<template>
  <v-container>
    <v-row class="text-center">
      <v-col class="mb-4">
        <h1 class="display-2 font-weight-bold mb-3">
          FPS Helper: Utilities For FPS Game Lovers
        </h1>
      </v-col>
    </v-row>
    <v-item-group active-class="primary">
      <v-container>
        <v-row>
          <v-col v-for="item in items" :key="item[0]" cols="12" md="4">
            <v-item>
              <v-card
                class="d-flex align-center grey lighten-4"
                height="200"
                @click="onSelect(item[1])"
              >
                <div color="white" class="text-h2 flex-grow-1 text-center">
                  {{ item[0] }}
                </div>
                <!-- <v-scroll-y-transition>
                  <div v-if="active" class="text-h2 flex-grow-1 text-center">
                    {{ names[n - 1] }}
                  </div>
                </v-scroll-y-transition> -->
              </v-card>
            </v-item>
          </v-col>
        </v-row>
      </v-container>
    </v-item-group>
    <v-card outlined>
      <v-card-title class="display-1">About This Website</v-card-title>
      <v-card-text class="title text-left">
        &nbsp;&nbsp;&nbsp;&nbsp;This website is designed to provide a wide range
        of utilities such as sensitivity converter and reation test for free for
        people who loves FPS games.
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
export default {
  name: "MainPage",

  metaInfo: {
    title: "FPS Helper/Utilities", // set a title
    meta: [
      {
        // set meta
        name: "keywords",
        content:
          "Mouse Sensitivity Converter, \
          Mouse Sensitivity calculator, \
          game Sensitivity Converter, \
          game Sensitivity calculator, \
          sens converter, \
          sense converter, \
          sensitivity calculator, \
          sens calculator,\
          reaction test, \
          reaction time, \
          human benchmark, \
          reaction speed test, \
          reflex test, \
          reaction, \
          reflex, \
          human reaction",
      },
      {
        // set meta
        name: "description",
        content:
          "This website is designed to provide a \
          wide range of utilities such as sensitivity converter and reation test for free for people who loves FPS games.",
      },
    ],
    link: [
      {
        // set link
        rel: "asstes",
        href: "http://fpshelper.com/en/",
      },
    ],
  },
  data: () => ({
    items: [
      ["Sensitivity Converter", "/conv"],
      ["Advanced Sensitivity Converter", "/advanced"],
      ["Reaction Time Test", "/reaction"],
    ],
  }),
  methods: {
    onSelect: function (target) {
      this.$router.push(target);
    },
  },
};
</script>
